import { render, staticRenderFns } from "./SelectTemplateConfirm.vue?vue&type=template&id=db8ee160&"
import script from "./SelectTemplateConfirm.vue?vue&type=script&lang=js&"
export * from "./SelectTemplateConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports